import classNames from "classnames";

import { BFC } from "shared/types";

type Props = {
  text: string;
  caption?: string;
  alignment?: "left" | "center" | "right";
};

export const ArticleQuoteBlock: BFC<Props> = ({
  text,
  caption,
  className,
}) => {
  return (
    <div className={classNames("border rounded p-4 bg-gray-100 text-black-500", className)}>
      <div
        dangerouslySetInnerHTML={{ __html: text }}
      />
      {caption && (
        <div className="mt-3 text-sm text-black-400">
          引用元 : <span className="underline">{caption}</span>
        </div>
      )}
    </div>
  );
};
